(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PRDetEmployeeComment', PRDetEmployeeComment);

    PRDetEmployeeComment.$inject = ['$resource'];

    function PRDetEmployeeComment($resource) {
        var resourceUrl = 'api/pr-det-employee-comments/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
